import { useEffect, useState } from "react"

const useDataClient = () => {
    const [language, setLanguage] = useState('');
    const [country, setCountry] = useState('');

    useEffect(() => {
        // Obtener el idioma del navegador
        const userLanguage = navigator.language ? navigator.language.split('-')[0] : 'en';
        setLanguage(userLanguage);

        // Obtener el país utilizando la API de IP Geolocation
        fetch(process.env.REACT_APP_IPINFO_HOST)
            .then((response) => response.json())
            .then((data) => setCountry(data.country.toLowerCase()))
            .catch((error) => console.error('Error al obtener la información del país:', error));
    }, []);

    return [language, country]
}

export default useDataClient
